export default __webpack_public_path__ + "static/media/thumb-banner3.512c692f.jpg";